import { BasicAppliedFilters } from 'app/components/design-system-components/list-filters/BasicAppliedFilters'
import { buildRenderedFilterConfig } from 'app/sm/manager_viewings/ManagerViewingsFilters/filters.config'

export const ManagerViewingsAppliedFilters = ({
  filters,
  onDismissFilter,
  enableFilters,
}: any) => {
  return (
    <BasicAppliedFilters
      filtersConfig={buildRenderedFilterConfig(filters)}
      onDismissFilter={onDismissFilter}
      enableFilters={enableFilters}
    />
  )
}
